import { PAGE_REVIEWS_TYPES } from 'views/information-module/ReviewsView/utils/CONSTANTS';
import { useTranslation } from 'next-i18next';
import PATHS from 'lib/navigation/paths';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

export const useGetReviewPageInfo = (pageType, reviews) => {
  const { t } = useTranslation('fe_er_reviews_page');
  const appNavigator = useAppNavigator();
  let mainTitleObject;
  let breadcrumbsObject;

  switch (pageType) {
    case PAGE_REVIEWS_TYPES.all_reviews:
      mainTitleObject = {
        name: t('fe_er_reviews_page:recent_customer_experience_ratings'),
      };
      breadcrumbsObject = {
        links: [
          {
            text: t('fe_er_reviews_page:EagleRider'),
            path: PATHS.home(),
          },
          {
            text: t('fe_er_reviews_page:Information'),
            path: PATHS.information(),
          },
          {
            text: t('fe_er_reviews_page:recent_customer_experience_ratings'),
          },
        ],
      };
      break;
    case PAGE_REVIEWS_TYPES.location_review:
      mainTitleObject = {
        name: t('fe_er_reviews_page:location_reviews', {
          location_name: reviews?.location?.name,
        }),
      };
      breadcrumbsObject = {
        links: [
          {
            text: t('fe_er_reviews_page:EagleRider'),
            path: PATHS.home(),
          },
          {
            text: t('fe_er_reviews_page:locations'),
            path: PATHS.locations(),
          },
          {
            text: reviews?.location?.name,
            path: PATHS.locationSlug(appNavigator.query.id),
          },
          {
            text: t('fe_er_reviews_page:location_reviews', {
              location_name: reviews?.location?.name,
            }),
          },
        ],
      };
      break;
    default:
      break;
  }

  return { mainTitleObject, breadcrumbsObject };
};
